module.exports = __webpack_public_path__ + "static/media/logo.28d04980.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.webp
// module id = 936
// module chunks = 0